module.exports = __webpack_public_path__ + "img/组1073.e2ede57b.png";